<loren-page-content>
    <mat-card-title>
        {{ "alarms.active_alarms" | transloco: { count: totalNumOfAlarms() ?? "-" } }}
        @if (hasAlarmsToShow()) {
            <button matButton="filled" (click)="clearAllFilters()" class="btn-secondary">
                {{ "alarms.clear_filters" | transloco }}
            </button>
        }
    </mat-card-title>
    @if (loading()) {
        <div class="loren-alarms-table-spinner">
            <mat-spinner/>
        </div>
    } @else {
        @if (isHandset && hasAlarmsToShow()) {
            <div class="loren-home-alarms-table-mobile-filters">
                <button matButton="filled" [matMenuTriggerFor]="assetsFilters">
                    {{ "alarms.filter_by_asset" | transloco }}
                </button>
                <button matButton="filled" [matMenuTriggerFor]="groupsFilters">
                    {{ "alarms.filter_by_group" | transloco }}
                </button>
                <button matButton="filled" [matMenuTriggerFor]="parametersFilters">
                    {{ "alarms.filter_by_parameter" | transloco }}
                </button>
                <button matButton="filled" [matMenuTriggerFor]="startFilters">
                    {{ "alarms.filter_by_start" | transloco }}
                </button>
            </div>
        }
        @if (!hasAlarmsToShow() || alarmsError()) {
            <div class="vertically-centered loren-alarms-none-content">
                <mat-icon class="loren-alarms-none-icon" svgIcon="no_data"></mat-icon>
                <span class="loren-alarms-none-text"
                >{{
                        !hasAlarmsToShow()
                            ? ("alarms.no_active_alarms" | transloco)
                            : ("alarms.error" | transloco)
                    }}
      </span>
            </div>
        } @else if (!alarmsSortedFiltered().length) {
            <div class="loren-alarms-table-container">
                @if (!isHandset) {
                    <table
                        #alarmsTable
                        mat-table
                        class="loren-alarms-table"
                        [dataSource]="alarmsSortedFiltered()">
                        <ng-container matColumnDef="rowNum">
                            <th
                                    mat-header-cell
                                    class="loren-alarms-table-header"
                                    *matHeaderCellDef></th>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.ASSET">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.asset" | transloco }}
                                <mat-icon class="loren-alarms-table-header-icon"
                                >import_export
                                </mat-icon
                                >
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [matMenuTriggerFor]="assetsFilters"
                                        #menuTrigger
                                >filter_alt
                                </mat-icon
                                >
                            </th>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.GROUPS">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.groups" | transloco }}
                                <mat-icon class="loren-alarms-table-header-icon"
                                >import_export
                                </mat-icon
                                >
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [matMenuTriggerFor]="groupsFilters"
                                        #menuTrigger
                                >filter_alt
                                </mat-icon
                                >
                            </th>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.PARAMETER">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.parameter_value" | transloco }}
                                <mat-icon class="loren-alarms-table-header-icon"
                                >import_export
                                </mat-icon
                                >
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [matMenuTriggerFor]="parametersFilters"
                                        #menuTrigger
                                >filter_alt
                                </mat-icon
                                >
                            </th>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.AUTOMATION_RULE">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.automation_rule" | transloco }}
                            </th>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.START">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.start" | transloco }}
                                <mat-icon class="loren-alarms-table-header-icon"
                                >import_export
                                </mat-icon
                                >
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [matMenuTriggerFor]="startFilters"
                                        #menuTrigger
                                >filter_alt
                                </mat-icon
                                >
                            </th>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.STATUS">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.status" | transloco }}
                            </th>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: columns"></tr>
                    </table>
                }
                <div class="vertically-centered loren-alarms-none-content">
                    <mat-icon class="loren-alarms-none-icon" svgIcon="no_data"></mat-icon>
                    <span class="loren-alarms-none-text"
                    >{{ "alarms.no_alarms_with_filters" | transloco }}
        </span>
                </div>
            </div>
        } @else {
            @if (isHandset) {
                @for (alarm of alarmsSortedFiltered(); track alarm) {
                    <div class="loren-table-mobile">
                        <div class="loren-table-mobile-header">
                            <span>{{ alarm[alarmColumns.ASSET] }}</span>
                            <span>{{ alarm[alarmColumns.START] | lorenDate }}</span>
                        </div>
                        <div class="loren-table-mobile-content">
                            <span>{{ "alarms.groups" | transloco }}</span>
                            <span>{{ alarm[alarmColumns.GROUPS] }}</span>
                            <span>{{ "alarms.parameter" | transloco }}</span>
                            <span>{{ alarm[alarmColumns.PARAMETER] }}</span>
                            <span>{{ "alarms.value" | transloco }}</span>
                            <span>{{ alarm.value }}</span>
                        </div>
                    </div>
                }
            } @else {
                <div class="loren-alarms-table-container">
                    <table
                        #alarmsTable
                        mat-table
                        class="loren-alarms-table"
                        [dataSource]="alarmsSortedFiltered()">
                        <ng-container matColumnDef="rowNum">
                            <th
                                    mat-header-cell
                                    class="loren-alarms-table-header"
                                    *matHeaderCellDef></th>
                            <td
                                    mat-cell
                                    class="loren-alarms-table-cell loren-alarms-table-cell-num"
                                    *matCellDef="let i = index">
                                {{ +i + 1 }}
                            </td>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.ASSET">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.asset" | transloco }}
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [ngClass]="{'loren-alarms-table-header-sorted': sorted()[alarmColumns.ASSET]}"
                                        (click)="sort(alarmColumns.ASSET)"
                                >import_export
                                </mat-icon>
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [matMenuTriggerFor]="assetsFilters"
                                        #menuTrigger
                                >filter_alt</mat-icon>
                            </th>
                            <td mat-cell class="loren-alarms-table-cell bold" *matCellDef="let element">
                                {{ element[alarmColumns.ASSET] }}
                            </td>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.GROUPS">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.groups" | transloco }}
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [ngClass]="{'loren-alarms-table-header-sorted': sorted()[alarmColumns.GROUPS]}"
                                        (click)="sort(alarmColumns.GROUPS)"
                                >import_export</mat-icon>
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [matMenuTriggerFor]="groupsFilters"
                                        #menuTrigger
                                >filter_alt</mat-icon>
                            </th>
                            <td mat-cell class="loren-alarms-table-cell" *matCellDef="let element">
                                {{ element[alarmColumns.GROUPS] }}
                            </td>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.PARAMETER">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.parameter_value" | transloco }}
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [ngClass]="{'loren-alarms-table-header-sorted': sorted()[alarmColumns.PARAMETER]}"
                                        (click)="sort(alarmColumns.PARAMETER)"
                                >import_export</mat-icon>
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [matMenuTriggerFor]="parametersFilters"
                                        #menuTrigger
                                >filter_alt</mat-icon>
                            </th>
                            <td mat-cell class="loren-alarms-table-cell" *matCellDef="let element">
                                <div class="loren-alarms-table-parameter">
                                    <span>{{ element[alarmColumns.PARAMETER] }}</span>

                                    <span class="loren-alarms-table-value bold">{{element.value }}</span>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.AUTOMATION_RULE">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.automation_rule" | transloco }}
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [ngClass]="{'loren-alarms-table-header-sorted': sorted()[alarmColumns.AUTOMATION_RULE]}"
                                        (click)="sort(alarmColumns.AUTOMATION_RULE)"
                                >import_export</mat-icon>
                            </th>
                            <td mat-cell class="loren-alarms-table-cell" *matCellDef="let element">
                                @if (element[alarmColumns.AUTOMATION_RULE]) {
                                    {{ element[alarmColumns.AUTOMATION_RULE] }}
                                }
                            </td>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.START">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.start" | transloco }}
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [ngClass]="{'loren-alarms-table-header-sorted': sorted()[alarmColumns.START]}"
                                        (click)="sort(alarmColumns.START)"
                                >import_export</mat-icon>
                                <mat-icon
                                        class="loren-alarms-table-header-icon"
                                        [matMenuTriggerFor]="startFilters"
                                        #menuTrigger
                                >filter_alt</mat-icon>
                            </th>
                            <td
                                    *matCellDef="let element"
                                    mat-cell
                                    class="loren-alarms-table-cell loren-alarms-table-cell-date">
                                {{ element[alarmColumns.START] | lorenDate }}
                            </td>
                        </ng-container>

                        <ng-container [matColumnDef]="alarmColumns.STATUS">
                            <th mat-header-cell class="loren-alarms-table-header" *matHeaderCellDef>
                                {{ "alarms.status" | transloco }}
                            </th>
                            <td mat-cell class="loren-alarms-table-cell" *matCellDef="let element">
                                <badge [variant]="element.isCritical ? 'danger' : 'warning'">
                                    {{ (element.isCritical ? "alarms.critical" : "alarms.warning") | transloco }}
                                </badge>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: columns"></tr>
                    </table>
                </div>
            }
        }
    }
    <loren-home-alarms-table-actions
            [totalNumOfAlarms]="totalNumOfAlarms()"
            [alarmsOnPage]="alarmsSortedFiltered().length"
            (alarmsIncreased)="alarmsIncreasedHandler()"
            (alarmsDecreased)="alarmsDecreasedHandler()"
            (selectionChanged)="selectionChangedHandler()">
    </loren-home-alarms-table-actions>
</loren-page-content>

<mat-menu #assetsFilters="matMenu">
    <ng-template matMenuContent
    >
        <loren-filters
                [placeholder]="'alarms.search_assets' | transloco"
                [items]="assetsFilter"
                [initiallySelected]="activeFilters()?.[alarmFilters.ASSET_IDS]"
                (selectionSubmitted)="filter(alarmFilters.ASSET_IDS, $event)">
        </loren-filters
        >
    </ng-template>
</mat-menu>
<mat-menu #groupsFilters="matMenu"
>
    <ng-template matMenuContent
    >
        <loren-filters
                [placeholder]="'alarms.search_groups' | transloco"
                [items]="groupsFilter()"
                [initiallySelected]="activeFilters()?.[alarmFilters.ASSET_GROUP_IDS]"
                (selectionSubmitted)="filter(alarmFilters.ASSET_GROUP_IDS, $event)">
        </loren-filters>
    </ng-template
    >
</mat-menu>
<mat-menu #parametersFilters="matMenu"
>
    <ng-template matMenuContent
    >
        <loren-filters
                [placeholder]="'alarms.search_parameters' | transloco"
                [initiallySelected]="activeFilters()?.[alarmFilters.ASSET_METERING_TYPE]"
                [items]="parametersFilter"
                (selectionSubmitted)="filter(alarmFilters.ASSET_METERING_TYPE, $event)">
        </loren-filters>
    </ng-template
    >
</mat-menu>
<mat-menu #startFilters="matMenu"
>
    <ng-template matMenuContent
    >
        <loren-filters
                [initiallySelected]="activeFilters()?.[alarmFilters.START_TIME]"
                [items]="startTimeFilters"
                [placeholder]="'alarms.start' | transloco"
                [showSearch]="false"
                [withNumber]="1"
                (selectionSubmitted)="filter(alarmFilters.START_TIME, $event)">
        </loren-filters>
    </ng-template
    >
</mat-menu>
